module.exports = __webpack_public_path__ + "img/bg1.9aa89c17.jpg";